/* eslint-disable i18next/no-literal-string */

import { TrackedButton } from "@outschool/ui-components-shared";
import { LoadingIcon } from "@outschool/ui-legacy-component-library";
import React from "react";

export interface RemoveCreatureButtonProps {
  isClearing: boolean;
  isGenerating?: boolean;
  onClear: () => Promise<void>;
}

export function RemoveCreatureButton({
  isClearing,
  isGenerating = false,
  onClear,
}: RemoveCreatureButtonProps) {
  return (
    <TrackedButton
      startIcon={isClearing ? <LoadingIcon /> : undefined}
      variant="outlined"
      color="secondary"
      size="small"
      onClick={onClear}
      disabled={isClearing || isGenerating}
      trackingName="avatar_builder.clear_avatars_button_clicked"
      sx={{ marginBottom: 10 }}
    >
      {isClearing ? "Removing..." : "Remove My Avatar"}
    </TrackedButton>
  );
}
